import React from 'react';
const WebformButton = ({ children, ...props }) => <button {...props}>{children}</button>;
export default WebformButton;
//# sourceMappingURL=WebformButton.jsx.map